import React from "react";
import styles from "./stylesComponent/CardProduct.module.css";
import { FaStar } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import { FaStarHalfAlt } from "react-icons/fa";
import {Link} from 'react-router-dom';



const CardProduct = ({ producto }) => {

    //Valoracion y datos del tutor del producto pasado
    const { tutor, rating } = producto;

    return(
        /*En cada tarjeta se muestra imagen, nombre del contenido, autor y temática (al menos 2, si hay más se muestran ...) */
        <div className={styles.card}>
            <div className={styles.image}>
                <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={`${producto.Nombre}`} />
            </div>
            <div className={styles.nombre}>
                <h3 title={producto.Nombre}>{producto.Nombre}</h3>
            </div>
                <p className={styles.descripcion}>{producto.Descripcion}</p>
                <strong><p className={styles.tutor}>{tutor.Nombre} {tutor.Apellidos}</p></strong>
                <div className={styles.tematicas} title={producto.Tematica?.join(", ")}>
                    <span>{producto.Tematica?.join(", ")}</span>
                </div>
                <div className={styles.valoracionPrecio}>
                    {Array.from({length: 5}, (_, index) =>{
                        const entero = Math.floor(rating);
                        const decimal = rating - entero;

                        if(index < entero) {
                            return <FaStar key={index} />;
                        }
                        else if (index === entero && decimal > 0.4){
                            return <FaStarHalfAlt key={index} />;
                        }
                        else{
                            return <FaRegStar key={index} />;
                        }
                    })}
                    <span>{(producto.Precio).toFixed(2)} €</span>
                </div>
                <div className={styles.boton}>
                    <Link to={{
                        pathname: `/detalleContenido/${producto._id}`, state: { producto: producto, tutor: tutor }
                    }}>
                        <button>Ver Detalles</button>
                    </Link>      
                </div>
        </div>
    );
};

export default CardProduct;